// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Loading from '../components/Loading';
import { useUserState } from '../contexts/UserContext';

export const AuthCheck: React.FC = () => {
  const { loggedInUser, isLoading, login } = useUserState(); // Generic Interface
  const nav = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoading) return;

    // If user is already logged in, ensure we aren't stuck on /login
    if (loggedInUser) {
      if (loggedInUser.isConnectedViaDapp && !loggedInUser.primaryParty) {
        nav('/sync');
        return;
      }
      if (location.pathname.includes('/login')) {
        nav('/');
      }
      return;
    }
    if (!loggedInUser) {
      nav('/login');
    }
  }, [loggedInUser, isLoading, nav, location, login]);

  if (isLoading || !loggedInUser) {
    return <Loading text="Authenticating..." />;
  }

  return <Outlet />;
};
